<template>
  <div>
    <template v-if="!loadingPageProfile">
      <template v-if="pageProfile.type == 'bearhouse'">
        <bearhouse-transfer></bearhouse-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'khaiwhan'">
        <khaiwhan-transfer></khaiwhan-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'ros'">
        <ros-transfer></ros-transfer>
      </template>
      <!-- <template v-else-if="pageProfile.type == 'gaigao'">
      <gai-gao-transfer></gai-gao-transfer>
    </template> -->
      <template v-else-if="pageProfile.type == 'forex'">
        <forex-transfer></forex-transfer>
      </template>
      <template v-else-if="['bec'].includes(pageProfile.type)">
        <BecTransfer></BecTransfer>
      </template>
      <template v-else-if="pageProfile.type == 'purelife'">
        <purelife-transfer></purelife-transfer>
      </template>
      <!-- <template v-else-if="pageProfile.type == 'monobo'">
        <monobo-transfer></monobo-transfer>
      </template> -->
      <template v-else-if="pageProfile.type == 'gaigacha'">
        <gaigacha-transfer></gaigacha-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'kanom'">
        <kanom-transfer></kanom-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'waratapob'">
        <waratapob-transfer></waratapob-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'rabbit'">
        <rabbit-transfer></rabbit-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'fastdeli'">
        <fastdeli-transfer></fastdeli-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'runkan'">
        <runkan-transfer></runkan-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'tremendous'">
        <multi-address-transfer></multi-address-transfer>
      </template>
      <template v-else-if="pageProfile.type == 'seagull'">
        <seagull-transfer></seagull-transfer>
      </template>
      <template v-else>
        <transfer></transfer>
      </template>
    </template>
    <Loading v-else></Loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const BearhouseTransfer = () => import('./BearhouseTransfer')
const Transfer = () => import('./Transfer')
const KhaiwhanTransfer = () => import('./KhaiwhanTransfer')
const RosTransfer = () => import('./RosTransfer')
const GaiGaoTransfer = () => import('./GaiGaoTransfer')
const ForexTransfer = () => import('./ForexTransfer')
const PurelifeTransfer = () => import('./PurelifeTransfer')
const MonoboTransfer = () => import('./MonoboTransfer')
const GaigachaTransfer = () => import('./GaigachaTransfer')
const KanomTransfer = () => import('./KanomTransfer')
const WaratapobTransfer = () => import('./WaratapobTransfer')
const BecTransfer = () => import('./BecTransfer/main.vue')
const RabbitTransfer = () => import('./RabbitTransfer')
const FastdeliTransfer = () => import('./FastdeliTransfer')
const RunkanTransfer = () => import('./RunkanTransfer')
const MultiAddressTransfer = () => import('./MultiAddressTransfer')
const SeagullTransfer = () => import('./SeagullTransfer')
import Loading from '@/components/Loading.vue'

export default {
  components: {
    BearhouseTransfer,
    RosTransfer,
    Transfer,
    KhaiwhanTransfer,
    GaiGaoTransfer,
    ForexTransfer,
    PurelifeTransfer,
    MonoboTransfer,
    GaigachaTransfer,
    KanomTransfer,
    WaratapobTransfer,
    BecTransfer,
    RabbitTransfer,
    FastdeliTransfer,
    RunkanTransfer,
    MultiAddressTransfer,
    SeagullTransfer,
    Loading
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    }
  },
  async mounted() {
    await this.$store.dispatch('loadPageProfile', {
      pagename: this.pagename,
      with_shipping_list: true
    })
  }
}
</script>

<style lang="scss" scoped></style>
